import { StoreGateLogGetRequestOrderEnum } from "../api/main";
import { EntranceOrder } from "../store/slice/logSlice";

export const entranceOrderEnumConverter = (order: EntranceOrder): StoreGateLogGetRequestOrderEnum => {
  switch (order) {
    case 'asc': return StoreGateLogGetRequestOrderEnum.Asc;
    case 'desc': return StoreGateLogGetRequestOrderEnum.Desc;
    default: return StoreGateLogGetRequestOrderEnum.Asc;
  }
}